var map = {
	"./ancient_parchment_scroll.webp": 127,
	"./beit_hamikdash_outer.webp": 975,
	"./cozy_library_shelf.webp": 490,
	"./large_bronze_mizbeach.webp": 792,
	"./ornate_seven-branched_menorah.webp": 788,
	"./passover_seder_plate.webp": 626,
	"./red_heifer_standing.webp": 330,
	"./rosh_hashana_plate.webp": 312,
	"./shabbat_dinner_table.webp": 949,
	"./stained-glass_window.webp": 32,
	"./temple_mount_silhouette.webp": 132,
	"./the_eastern_gate.webp": 907,
	"./treasury_room.webp": 895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 640;